// export const baseUrl = "https://www.fineoutput.co.in/supremetech/Apicontroller/";
export const baseUrl = "https://www.supremetechnocom.com/backend/Apicontroller/";